<template>
    <div class="fm-internal">
        <div style="max-width: 800px;  min-width: 300px;">
            <b-card no-body>
                <!-- <div class="error">{{ error }}</div>
                <div class="decode-result">Last result: <b>{{ decoded }}</b></div> -->
                <qrcode-stream @decode="on_decode" @init="on_init"></qrcode-stream>
            </b-card>
        </div>
    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'
    import { QrcodeStream } from 'vue-qrcode-reader'

    export default {
        name: "Scanner",
        props: [],
        components: { QrcodeStream, Multiselect, Backer},
        data: function(){
            return {
                userDetails: {properties: {}},
                result: '',
                error: '',
                decoded: {},
                show_options: {
                    "store_transfer": {},
                    "customer_delivery": {},
                }
            }
        },
        methods: {
            on_decode: function(result) {
                this.result = results
                let parsed = this.try_parse(this.result);
                if (parsed == null) {
                    //validate if its a url
                    if (this.is_valid_url(this.result)) {
                        window.location = this.result
                    }
                    else {
                        console.log("not sure")
                    }
                }
                else {
                    this.decoded = parsed;
                    this.$emit("onScannerInput", JSON.stringify(this.decoded));
                }
            },
            try_parse: function(value){
                let output = {};
                try {
                    let splt = value.split("|");
                    if (splt.length > 0){
                        output = {uid: splt[0], product_sku: splt[1], product_id: splt[2]}
                    }
                }
                catch (e) {
                    output = null
                }
                return output
            },

            async on_init (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                    this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }
            },
            is_valid_url: function(string) {
                try {
                    new URL(string);
                } catch (_) {
                    return false;  
                }
                return true;
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                //this.fetch_prereqs();           
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/Scanner.vue